import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import AnimateHeight from "react-animate-height";
import { Check, AlertCircle, Info } from "react-feather";
import { toast } from "react-toastify";
import { Distribution } from "../../../models";
import { DatePickerInput } from "../../shared/components/DatePicker/DatePickerInput";
import { EffektButton } from "../../shared/components/EffektButton/EffektButton";
import { EffektCheckbox } from "../../shared/components/EffektCheckbox/EffektCheckbox";
import { Lightbox } from "../../shared/components/Lightbox/Lightbox";
import { DistributionController } from "../shared/DistributionCauseAreaInput/Distribution";
import { updateAnonymousVippsAgreementDistribution, cancelAnonymousVippsAgreement, updateAnonymousVippsAgreementDay, updateAnonymousVippsAgreementPrice } from "../shared/lists/agreementList/_queries";
import style from "./AnonymousVippsAgreement.module.scss";
import { SumInput } from "../shared/SumInput/SumInput";
import { useFailureToast } from "../../shared/failureToast";
export const AnonymousVippsAgreement: React.FC<{
  inputSum: number;
  inputDate: number;
  inputDistribution: Distribution;
  endpoint: string;
}> = t0 => {
  const $ = _c(3);
  const {
    inputSum,
    inputDate,
    inputDistribution
  } = t0;
  useFailureToast();
  useState(inputDistribution);
  useState(inputDate);
  let t1;
  if ($[0] !== inputSum) {
    t1 = inputSum.toFixed(0);
    $[0] = inputSum;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useState(t1);
  useState(false);
  useState(false);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div>Midlertidig ute av drift, ta kontakt på donasjon@gieffektivt.no</div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
const successToast = () => toast.success("Lagret", {
  icon: <Check size={24} color={"black"} />
});
const partialFailureToast = () => toast.error("Noen endringer feilet", {
  icon: <AlertCircle size={24} color={"black"} />
});
const noChangesToast = () => toast.error("Ingen endringer", {
  icon: <Info size={24} color={"black"} />
});
const invalidInputToast = () => toast.error("Ugyldig data inntastet", {
  icon: <AlertCircle size={24} color={"black"} />
});